<template>
    <tr class="lms__superadmin_auditlog_list_table_item">
        <td class="lms__superadmin_auditlog_list_table_item_eventtype">{{ auditLogEventType }}</td>
        <td class="lms__superadmin_auditlog_list_table_item_time">
            {{ auditLogDate }}
            <component-text :size="'tiny'">
                Time: {{ auditLogTime }}
            </component-text>
        </td>
        <td class="lms__superadmin_auditlog_list_table_item_affectedobject">{{ auditLogAffectedObject }}</td>
        <td class="lms__superadmin_auditlog_list_table_item_source" v-html="auditLogSource"></td>
        <td class="lms__superadmin_auditlog_list_table_item_result">
            <component-status :status="auditLogResult"></component-status>
        </td>
        <td class="lms__superadmin_auditlog_list_table_item_description">{{ auditLogOperation }}</td>
    </tr>
</template>

<script>
import ComponentButton from '@/components/default/shared/ComponentButton'
import { fromCamelCaseToString, fromUTCDateTimeToLocalISOCustom, indexOfRegex, lastIndexOfRegex, toCapitalize, toLocaleDateTime, toLocaleTime } from '@/functions'
import ComponentText from '@/components/default/shared/ComponentText'
import ComponentStatus from '@/components/default/shared/ComponentStatus'

export default {
  name: 'lms-superadmin-audit-log-list-table-item',
  components: { ComponentStatus, ComponentText, ComponentButton },
  props: {
    item: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    auditLogId () {
      return this.item.id
    },
    auditLogEventType () {
      return toCapitalize(fromCamelCaseToString(this.item.eventClass))
    },
    auditLogOperation () {
      return this.item.operation
    },
    auditLogAffectedObject () {
      const operation = this.auditLogOperation
      let output = operation ? operation.substring(indexOfRegex(operation, /[{]\w+[:]/, 1), lastIndexOfRegex(operation, /[{]\w+[:]/)) : ''
      output = output ? toCapitalize(output) : ''

      return output
    },
    auditLogDate () {
      return this.item.date ? toLocaleDateTime(fromUTCDateTimeToLocalISOCustom(this.item.date)) : '-'
    },
    auditLogTime () {
      return this.item.date ? toLocaleTime(fromUTCDateTimeToLocalISOCustom(this.item.date)) : '-'
    },
    auditLogUserId () {
      return this.item.userId
    },
    auditLogUserName () {
      return this.item.userName
    },
    auditLogSource () {
      const auditLogServiceName = this.auditLogServiceName
      const auditLogUserId = this.auditLogUserId
      const auditLogUserName = this.auditLogUserName
      const apiKey = JSON.parse(JSON.stringify(this.item.userId))
      let apiKeyArr = apiKey.split('')

      for (let index in apiKeyArr) {
        const indexNumber = Number(index) + 1
        const arrLength = apiKeyArr.length

        if (indexNumber && indexNumber % 5 === 0 && indexNumber !== arrLength) {
          apiKeyArr[index] += ' - '
        }
      }

      const apiKeyOutput = apiKeyArr.join('').slice(0, 10)

      let output
      if (auditLogServiceName === 'euma') {
        output = `API<br><span>Code starting: \n${apiKeyOutput}</span>`
      } else if (auditLogServiceName === 'form') {
        output = auditLogServiceName
      }
      return output
    },
    auditLogUserType () {
      return this.item.userType
    },
    auditLogServiceName () {
      return this.item.serviceName
    },
    auditLogResult () {
      return this.item.success ? 'successful' : 'failed'
    }
  }
}
</script>
